var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"timeline-talks"},[_vm._v(_vm._s(_vm.message))]),(_vm.blockTags)?_c('tags',{attrs:{"status-type":_vm.blockTags.rating,"tag-icon":_vm.blockTags.icon,"tag-heading":_vm.blockTags.heading}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }